import React from "react";
import errorPage from "../../assets/images/Home/broken_page.png";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { Col, Container, Row } from "react-bootstrap";

function NotFound() {
  return (
    <div className="error_page">
      <div className="page_header"></div>
      <Container>
        <Row className="align-items-center">
          <Col>
            <div className="error_Content">
              <h1 className="title">This Page Does Not Exist</h1>
              <p className="text">
                Sorry, the page you are looking for could not be found. It's
                just an accident that was not intentional.
              </p>
              <Link to="/" className="educate-btn my-2">
                <span className="educate-btn__curve"></span>
                <FaArrowLeft className="me-2" />
                Back To Home
              </Link>
            </div>
          </Col>
          <Col md="6">
            <img src={errorPage} alt="Page Not Found" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default NotFound;
